import { type AnyObject, AppRegions } from 'models';

import { AppLanguages } from './app.constants';

// ******** ESTONIAN ********

const EE_ENGLISH_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Customer Support',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['ENGLISH'],
      select: 'ENGLISH',
    },
    prechatForm: {
      greeting: {
        '*': 'Hello,\n\nThank you for contacting us. \nOur Customer Success managers are ready to reply to your questions Mon-Fri 09:00-19:00.\n\nFAQ questions can be found here: https://esto.eu/ee/kliendile/kliendile-klienditugi?lang=en',
      },
      departmentLabel: {
        '*': 'Language',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Help' },
    label: { '*': 'Help' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Customer Support',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Eesti',
      },
    },
  },
};

const EE_ESTONIAN_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Klienditugi',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['EESTI'],
      select: 'EESTI',
    },
    prechatForm: {
      greeting: {
        '*': 'Tere,\nTäname, et võtsite meiega ühendust.\nKlienditugi vastab Teie küsimustele esmaspäevast - reedeni 09:00 - 18:00.\nKorduma kippuvad küsimused leiate siit: https://esto.eu/ee/kliendile/kliendile-klienditugi?lang=et',
      },
      departmentLabel: {
        '*': 'Keel',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Abi' },
    label: { '*': 'Abi' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Klienditugi',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Eesti',
      },
    },
  },
};

const EE_RUSSIAN_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Поддержка клиентов',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['РУССКИЙ'],
      select: 'РУССКИЙ',
    },
    prechatForm: {
      greeting: {
        '*': 'Здравствуйте\nСпасибо что связались с нами. \nНаши специалисты готовы ответить на Ваши вопросы по рабочим дням с 9:00 до 19:00\n\nЧАВО или часто задаваемые вопросы Вы можете найти здесь: https://esto.eu/ee/kliendile/kliendile-klienditugi?lang=ru',
      },
      departmentLabel: {
        '*': 'Язык',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Помощь' },
    label: { '*': 'Помощь' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Поддержка клиентов',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Eesti',
      },
    },
  },
};

// ******** LATVIAN ********

const LV_ENGLISH_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Customer Support',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['EN'],
      select: 'EN',
    },
    prechatForm: {
      greeting: {
        '*': 'Hello,\n\nThank you for contacting us. \nOur Customer Success managers are ready to reply to your questions Mon-Fri 09:00-19:00.\n\nFAQ questions can be found here: https://esto.eu/lv/klientiem/klientiem-atbalsts?lang=en',
      },
      departmentLabel: {
        '*': 'Language',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Help' },
    label: { '*': 'Help' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Customer Support',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Latvija',
      },
    },
  },
};

const LV_LATVIAN_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Klientu apkalpošana',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['LV'],
      select: 'LV',
    },
    prechatForm: {
      greeting: {
        '*': 'Paldies, ka sazinājāties ar mums!\nKlientu apkalpošanas speciālisti ir gatavi atbildēt uz Jūsu jautājumiem no pirmdienas līdz piektdienai 09.00 - 18.00\n\nBUJ atradīsiet šeit: https://esto.eu/lv/klientiem/klientiem-atbalsts?lang=lv',
      },
      departmentLabel: {
        '*': 'Valodu',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Palīdzība' },
    label: { '*': 'Palīdzība' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Klientu apkalpošana',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Latvija',
      },
    },
  },
};

const LV_RUSSIAN_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Поддержка клиентов',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['RU'],
      select: 'RU',
    },
    prechatForm: {
      greeting: {
        '*': 'Здравствуйте\nСпасибо что связались с нами. \nНаши специалисты готовы ответить на Ваши вопросы по рабочим дням с 9:00 до 19:00\n\nЧАВО или часто задаваемые вопросы Вы можете найти здесь: https://esto.eu/lv/klientiem/klientiem-atbalsts?lang=ru',
      },
      departmentLabel: {
        '*': 'Язык',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Помощь' },
    label: { '*': 'Помощь' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Поддержка клиентов',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Latvija',
      },
    },
  },
};

// ******** LITHUANIAN ********

const LT_ENGLISH_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Customer Support',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['ENG'],
      select: 'ENG',
    },
    prechatForm: {
      greeting: {
        '*': 'Hello,\n\nThank you for contacting us. \nOur Customer Success managers are ready to reply to your questions Mon-Fri 09:00-19:00.\n\nFAQ questions can be found here: https://esto.eu/lt/asmeninis/asmeninis-parama?lang=en',
      },
      departmentLabel: {
        '*': 'Language',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Help' },
    label: { '*': 'Help' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Customer Support',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Lietuva',
      },
    },
  },
};

const LT_LITHUANIAN_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Klientų aptarnavimas ',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['LTU'],
      select: 'LTU',
    },
    prechatForm: {
      greeting: {
        '*': 'Ačiū, kad susisiekėte su mumis!\nKlientų aptarnavimo komanda pasiruošusi atsakyti į jūsų klausimus pirmadieniais-penktadieniais 09.00 - 18.00 val.\n\nDUK galite patikrinti čia: https://esto.eu/lt/asmeninis/asmeninis-parama?lang=lt',
      },
      departmentLabel: {
        '*': 'Kalba',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Pagalba' },
    label: { '*': 'Pagalba' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Klientų aptarnavimas',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Lietuva',
      },
    },
  },
};

const LT_RUSSIAN_CHAT_CONFIG = {
  chat: {
    title: {
      '*': 'Поддержка клиентов',
    },
    concierge: {
      avatarPath:
        'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: 'ESTO',
      title: { '*': 'esto.eu' },
    },
    departments: {
      enabled: ['RUS'],
      select: 'RUS',
    },
    prechatForm: {
      greeting: {
        '*': 'Здравствуйте\nСпасибо что связались с нами. \nНаши специалисты готовы ответить на Ваши вопросы по рабочим дням с 9:00 до 19:00\n\nЧАВО или часто задаваемые вопросы Вы можете найти здесь: https://esto.eu/lt/asmeninis/asmeninis-parama?lang=ru',
      },
      departmentLabel: {
        '*': 'Язык',
      },
    },
  },
  launcher: {
    chatLabel: { '*': 'Помощь' },
    label: { '*': 'Помощь' },
  },
  answerBot: {
    contactOnlyAfterQuery: true,
    title: {
      '*': 'Поддержка клиентов',
    },
    avatar: {
      url: 'https://theme.zdassets.com/theme_assets/11129639/f338f25109624b5ef96cdfb5507ba9855ef39451.png',
      name: {
        '*': 'ESTO Lietuva',
      },
    },
  },
};

export const ZENDESK_CHAT_CONFIG_BY_REGIONS_AND_LANGUAGES_MAP: Record<
  AppRegions,
  Record<AppLanguages, AnyObject>
> = {
  [AppRegions.EE]: {
    [AppLanguages.en]: EE_ENGLISH_CHAT_CONFIG,
    [AppLanguages.et]: EE_ESTONIAN_CHAT_CONFIG,
    [AppLanguages.ru]: EE_RUSSIAN_CHAT_CONFIG,
    [AppLanguages.lt]: {},
    [AppLanguages.lv]: {},
  },
  [AppRegions.LV]: {
    [AppLanguages.en]: LV_ENGLISH_CHAT_CONFIG,
    [AppLanguages.lv]: LV_LATVIAN_CHAT_CONFIG,
    [AppLanguages.ru]: LV_RUSSIAN_CHAT_CONFIG,
    [AppLanguages.lt]: {},
    [AppLanguages.et]: {},
  },
  [AppRegions.LT]: {
    [AppLanguages.en]: LT_ENGLISH_CHAT_CONFIG,
    [AppLanguages.lt]: LT_LITHUANIAN_CHAT_CONFIG,
    [AppLanguages.ru]: LT_RUSSIAN_CHAT_CONFIG,
    [AppLanguages.et]: {},
    [AppLanguages.lv]: {},
  },
};
